import { makeStyles } from "@fluentui/react-components";
import { BadgeStatusType } from "../../../../utils/common/Constants";
import { formatDisplayValue } from "../../../../utils/common/FormatHelper";
import { StandStatusTypes } from "../../../../utils/flights/FlightConstants";
import { getFlightStatusBadgeType } from "../../../../utils/flights/FlightHelperFunctions";
import {
  GateFlightInfo,
  GateTooltipRow,
} from "../../../../utils/maps/GateConstants";
import StatusDot from "../../../common/status/StatusDot";

const getStatusDotType = (status?: StandStatusTypes): BadgeStatusType =>
  status ? getFlightStatusBadgeType(status) : "subtle";

const GateTooltipCell: React.FC<{
  flightInfo: GateFlightInfo;
  row: GateTooltipRow;
}> = ({ flightInfo, row }) => {
  const styles = useStyles();

  if (row.showStatus) {
    return (
      <span className={styles.timeLabel}>
        <StatusDot status={getStatusDotType(flightInfo[row.statusField])} />
        {formatDisplayValue(flightInfo[row.field])}
      </span>
    );
  }

  return (
    <span className={styles.content}>
      {formatDisplayValue(flightInfo[row.field])}
    </span>
  );
};

export default GateTooltipCell;

const useStyles = makeStyles({
  timeLabel: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  content: {
    paddingLeft: "12px",
    overflowWrap: "anywhere",
  },
});
